// Centralized user utility helper functions

/**
 * Resolves the user's name from their dynamic sequential numeric ID or legacy string name.
 * 
 * @param {Array} users Array of active dynamic user profiles from Firestore
 * @param {string|number} id User identifier (numeric ID or name string)
 * @returns {string} The resolved user name
 */
export const getUserName = (users = [], id) => {
  if (!id) return "";
  const foundById = users.find(u => String(u.id) === String(id));
  if (foundById) return foundById.name;
  const foundByName = users.find(u => u.name.toLowerCase().trim() === String(id).toLowerCase().trim());
  if (foundByName) return foundByName.name;
  return id;
};

/**
 * Compares two user identifiers case-insensitively, supporting dynamic IDs and legacy string signups.
 * 
 * @param {Array} users Array of active dynamic user profiles from Firestore
 * @param {string|number} idA First user identifier
 * @param {string|number} idB Second user identifier
 * @returns {boolean} True if they represent the same user profile, otherwise false
 */
export const isSameUser = (users = [], idA, idB) => {
  if (!idA || !idB) return false;
  if (String(idA).toLowerCase().trim() === String(idB).toLowerCase().trim()) return true;
  const userObjA = users.find(u => String(u.id) === String(idA) || u.name.toLowerCase().trim() === String(idA).toLowerCase().trim());
  const userObjB = users.find(u => String(u.id) === String(idB) || u.name.toLowerCase().trim() === String(idB).toLowerCase().trim());
  if (userObjA && userObjB && userObjA.id === userObjB.id) return true;
  return false;
};
